import { render, staticRenderFns } from "./whitePaperList.vue?vue&type=template&id=731781e0&scoped=true&"
import script from "./whitePaperList.vue?vue&type=script&lang=js&"
export * from "./whitePaperList.vue?vue&type=script&lang=js&"
import style0 from "./whitePaperList.vue?vue&type=style&index=0&id=731781e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731781e0",
  null
  
)

export default component.exports